// extracted by mini-css-extract-plugin
export default {"logo":"SidebarAdmin_logo__3Knym","menuTitle":"SidebarAdmin_menuTitle__z66qA","active":"SidebarAdmin_active__TJGZG","activeLink":"SidebarAdmin_activeLink__hqqSD"};